import { BaseMeiucaService } from './MeiucaService'
import { env } from '@/lib/env'
import { Modality, ModalitiesResponse } from '@/types/modality'

class ModalityService extends BaseMeiucaService {
  /**
   * Get all available modalities
   * @returns Array of modalities with id and description
   */
  async getModalities(): Promise<Modality[]> {
    const response = await this.get<ModalitiesResponse>('/modalities')
    return response.data.data
  }
}

export const modalityService = new ModalityService({
  baseURL: env.API_URL,
  refreshEndpoint: '/v1/auth/refresh',
  cookiePrefix: '',
  debug: env.IS_DEVELOPMENT,
})
